import { Navbar } from "@blueprintjs/core"
import React from "react"

import AppNavbar from "../Molecules/AppNavbar"
import CustomButton from "./CustomButton"
import VesatogoBrand from "./VesatogoBrand"
const LandingHeader = () => {
  const linkTo = link => {
    window.location.href = link
  }
  return (
    <AppNavbar heading={<VesatogoBrand brandText="VesatoGo" />}>
      <CustomButton
        icon="envelope"
        text="vesatogo111@gmail.com"
        onClick={() => linkTo("mailto:vesatogo111@gmail.com")}
      />
      <Navbar.Divider />
      <CustomButton
        icon="phone"
        text="+91 85520 72365"
        onClick={() => linkTo("tel:+918552072365")}
      />
    </AppNavbar>
  )
}

export default LandingHeader
